import Button from 'components/Button/Button'
import styled from 'styled-components'

export const StyledTableError = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70%;
  color: #495057;

  h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
  }

  h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
`

export const StyledWarningIcon = styled.div`
  path {
    stroke: #f18500;
  }
  circle {
    stroke: #f18500;
  }
  line {
    stroke: #f18500;
  }
`
export const StyledTryAgainButton = styled(Button)<any>`
  min-width: 100px;
  height: 26px;
`
